import * as Yup from "yup";

// フォームの型
export interface FormValues {
  personalInfo: {
    name: string;
    name_reading: string;
    birthDate: Date | null;
    gender: string;
    school: string;
    school_major: string;
    school_grade: string;
    address: string;
    tel_no: string;
    skill: string;
    hobby: string;
    blog: string;
    games: string;
    animes: string;
  };
}

// バリデーション
export const validationSchema = Yup.object().shape({
  personalInfo: Yup.object().shape({
    name: Yup.string().required("名前は必須です"),
    name_reading: Yup.string().required("フリガナは必須です"),
    birthDate: Yup.date().nullable().required("生年月日は必須です"),
    gender: Yup.string().required("性別を選択してください"),
    school: Yup.string().required("学校名は必須です"),
    school_grade: Yup.string().required("学年は必須です"),
  }),
});

// 初期値
export const initialValues: FormValues = {
  personalInfo: {
    name: "",
    name_reading: "",
    birthDate: null,
    gender: "",
    school: "",
    school_major: "",
    school_grade: "",
    address: "",
    tel_no: "",
    skill: "",
    hobby: "",
    blog: "",
    games: "",
    animes: "",
  },
};
